import ApiError from '../../../../entities/api-error/ApiError'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestSettings {
  type: DashboardActionTypes.REQUEST_SETTINGS;
}

export function requestSettings(): RequestSettings {
  return {
    type: DashboardActionTypes.REQUEST_SETTINGS,
  }
}

export interface RequestSettingsSuccess {
  type: DashboardActionTypes.REQUEST_SETTINGS_SUCCESS;
  payload: {
    storeName: string
    refreshInterval: number
  }
}

export function requestSettingsSuccess({
  storeName,
  refreshInterval,
}: RequestSettingsSuccess['payload']): RequestSettingsSuccess {
  return {
    type: DashboardActionTypes.REQUEST_SETTINGS_SUCCESS,
    payload: {
      storeName,
      refreshInterval,
    },
  }
}

export interface RequestSettingsFailure {
  type: DashboardActionTypes.REQUEST_SETTINGS_FAILURE;
  payload: {
    error:  ApiError;
  }
}

export function requestSettingsFailure({
 error,
}: RequestSettingsFailure['payload']): RequestSettingsFailure {

  return {
    type: DashboardActionTypes.REQUEST_SETTINGS_FAILURE,
    payload: {
      error,
    },
  }
}
